import Vue from "vue";
import iView from "view-design";
import Util from "@/libs/util";
import api from "@/libs/api";
import store from "@/store";
import VueRouter from "vue-router";
import Cookies from "js-cookie";
import { routers, otherRouter, appRouter, page404 } from "./router";

Vue.use(VueRouter);
Vue.use(iView);

// 路由配置
const RouterConfig = {
  mode: "history",
  routes: routers
};

export const router = new VueRouter(RouterConfig);

const menuList = JSON.parse(localStorage.getItem("menuList")) || []
if (!menuList.length) {
  Cookies.remove('userId');
  Cookies.remove('token');
  Cookies.remove('userName');
  localStorage.clear()
  router.push({
    name: "login",
  })
}

router.beforeEach((to, from, next) => {


  console.log(to, 'too', from, '-hahahah')
  // if ()
  if (from.name === 'flow-create') {
    if (store.state.app.backConfirm) {
      iView.Modal.confirm({
        title: '确认是否离开？',
        content: '<p>当前画布流程尚未发布或保存，请确认是否直接离开？</p>',
        onOk: () => {
          return next()
        },
        onCancel: () => {
        }
      })
      return
    }
    store.state.app.backConfirm = true
  }

  if (to.name === 'channel-link') {
    return next()
  }
  if (to.name === 'dashboard-end') {
    return next()
  }

  iView.LoadingBar.start();
  Util.title(to.meta.title);
  let userId = Cookies.get("userId");

  if (!(store.state.dashboards.dashboardTitle.id) && to.params) {
    store.commit('SET_DASHBOARD_TITLE', {
      id: to.params.projectId
    })
  }

  var url = location.search; //获取url中"?"符后的字串
  if (url.indexOf("?") != -1 & url.indexOf("token") != -1 & url.indexOf("userId") != -1 & url.indexOf("userName") != -1) {

    //
    //判断是否有参数
    // var str = ; //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
    let strs = url.substr(1).split("&"); //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
    let userId = strs[1].split("=")[1];
    let token = strs[0].split("=")[1];
    let userName = strs[2].split("=")[1];

    let oldUserId = Cookies.get("userId");
    let oldToken = Cookies.get("token");

    if (!(oldUserId && oldToken && userId && token && oldUserId === userId && oldToken === token)) {
      Cookies.set("token", token);
      Cookies.set("userId", userId);
      Cookies.set("userName", userName);
      api.getSessionData().then((res) => {

        if (res.data.status === 1) {
          store.commit('SET_ORGANIZATION_ID', res.data.fields.organizationId);
          store.commit('SET_USER_INFO', res.data.fields);
          next({
            name: "home"
          });

        }
      });
    }

    // } else

    // let url = location.search;
    // if (url.indexOf("?") >= 0) {
    //   // if (location.pathname === '/' && url.indexOf("?") >= 0) {
    //   let strs = url.substr(1).split("&"); //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
    //   let newUserId = strs[1].split("=")[1];
    //   let newToken = strs[0].split("=")[1];
    //   let token = Cookies.get('token');
    //   if (!(token && newToken && userId && newUserId && newUserId === userId && newToken == token)) {
    //     return;
    //   }
  }

  if (/dashboard/.test(to.path) && to.query.userId && to.query.token) next();
  //test页面不验证token
  else if (!userId && to.name !== "login") {

    // 判断是否未登录且前往的页面不是登录页
    /*store.commit('SET_MENU_LIST', []);   //删除菜单
    store.commit('SET_PROJECT_ID', null);  //删除项目信息
    store.commit('SET_PROJECT_TITLE', '无');  //删除项目名称
    localStorage.clear();*/
    Cookies.remove('userId');
    Cookies.remove('token');
    Cookies.remove('userName');
    localStorage.clear()
    next({
      name: "login"
    });
  } else if (userId && to.name === "login") {

    // 判断是否已经登录且前往的是登录页
    Util.title();
    next({
      name: "home"
    });
  } else {

    //appRouter=>防止死循环,刷新页面时重新加载动态路由；
    //menuList=>登录的时候，刷新页面菜单；
    if (
      userId &&
      (appRouter.children.length === 0)
    ) {

      const getResourceTree = new Promise(resolve => {
        api.getResource().then(res => {
          if (res.data.status === 1) {
            let list = res.data.fields.list.filter(
              item => item.type === "SidebarMenu"
            );
            let otherList = res.data.fields.list.filter(
              item => item.type !== "SidebarMenu"
            );
            let storage = JSON.parse(localStorage.getItem(`projectId`));
            // console.log(storage, "storage");
            if (
              !storage
            ) {
              // console.log(list, "llllllllllll");
              store.commit("SET_MENU_TREE", list);
              store.commit("SET_MENU_LIST", list[0] ? list[0].children : []);
              store.commit(
                "SET_PROJECT_ID",
                list[0]
                  ? list[0].projectId
                  : otherList[0]
                    ? otherList[0].projectId
                    : 0
              );
              store.commit(
                "SET_PROJECT_TITLE",
                list[0]
                  ? list[0].title
                  : otherList[0]
                    ? otherList[0].title
                    : "无"
              );
            } else {
              store.commit("SET_MENU_TREE", JSON.parse(localStorage.getItem("menuTree")) || []);
              store.commit("SET_MENU_LIST", JSON.parse(localStorage.getItem("menuList")) || []);
              store.commit("SET_PROJECT_ID", localStorage.getItem("projectId"));
              store.commit("SET_PROJECT_TITLE", localStorage.getItem("projectTitle") || '无');
            }
            store.commit("SET_OTHER_LIST", otherList);
            store.commit("UPDATE_ROUTERS", list);
            router.selfAddRoutes([appRouter, otherRouter, page404]);
            /*if (list.length === 0) {
                next({
                  name: 'project-management'
                });
              } else {*/
            next({ ...to, replace: true });
            // }
            resolve();
          }
        });
      });
      getResourceTree.then(() => {
        let len = store.state.app.menuList.length;
        if (len !== 0) Util.setDashboardsMenu();
      });
    } else {

      Util.toDefaultPage([...routers], to.name, router, next);
    }
  }
});




router.beforeEach((to, from, next) => {
  let requests = store.state.app.requests;
  requests.length && requests.forEach(pending => pending.f && pending.f());
  store.commit("SET_REQUESTS", []);
  next();
});

router.afterEach((to, from) => {
  if (from.meta && from.meta.title === '事件分析') {
    localStorage.removeItem('event_analysis_cache')
  }
  Util.userId = Cookies.get("userId");
  Util.token = Cookies.get("token");
  // Util.openNewPage(router.app, to.name, to.params, to.query);
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

router.selfAddRoutes = function (params) {
  router.matcher = new VueRouter({
    mode: "history",
    routes: routers
  }).matcher;
  router.addRoutes(params);
};



// WEBPACK FOOTER //
// ./src/router/index.js